export var DsgStorageTier;
(function (DsgStorageTier) {
    DsgStorageTier["DSG_STORAGE_TIER_STANDARD"] = "STANDARD";
    DsgStorageTier["DSG_STORAGE_TIER_ARCHIVE"] = "ARCHIVE";
})(DsgStorageTier || (DsgStorageTier = {}));
